<h2 mat-dialog-title>{{'ERROR_DIALOG.STATUS.' + data.error.status + '.TITLE' | translate}}</h2>
<mat-dialog-content>{{'ERROR_DIALOG.STATUS.' + data.error.status + '.CONTENT' | translate}}</mat-dialog-content>
<mat-dialog-actions class="btn-uppercase align-right">
  <button mat-button color="primary" (click)="reload()">
    {{'ERROR_DIALOG.BUTTONS.RELOAD' | translate}}
  </button>
</mat-dialog-actions>
